 <!-- Content Wrapper. Contains page content -->
 <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <!-- <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Dashboard</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a routerLink="/app/dash">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
        </div> -->
      </div>
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <section class="content" >
      <div class="container-fluid">
        <!-- Small boxes (Stat box) -->
        <div class="row">
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-info">
              <div class="inner">
                <!-- <h3></h3> -->

                <p>Fees</p>
              </div>
              <div class="icon">
                <i class="ion ion-bag"></i>
              </div>
              <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-success">
              <div class="inner">
                <!-- <h3>53<sup style="font-size: 20px">%</sup></h3> -->

                <p>Attendance</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-warning">
              <div class="inner">
                <!-- <h3>44</h3> -->

                <p>Library Visits</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <!-- <h3>65</h3> -->

                <p>Unique Visitors</p>
              </div>
              <div class="icon">
                <i class="ion ion-pie-graph"></i>
              </div>
              <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
            </div>
          </div>
          <!-- ./col -->
        </div>
        <!-- /.row -->
        <!-- Main row -->
        <div class="row">
          <!-- Left col -->
          <section class="col-lg-7 connectedSortable">
            <!-- Custom tabs (Charts with tabs)-->
            <!-- <div class="card card-primary card-outline">
              <div class="card-header ">

                <h3 class="card-title">
                  <i class="far fa-image"></i>
                 Gallery
                </h3>
             
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
                
              </div>

              
              <div class="card-body p-0">
              
            
                <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                  <ol class="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                  </ol>
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <img class="d-block w-100" src="assets/dist/img/photo1.png" alt="First slide">
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="assets/dist/img/photo2.png" alt="Second slide">
                    </div>
                    <div class="carousel-item">
                      <img class="d-block w-100" src="assets/dist/img/photo3.jpg" alt="Third slide">
                    </div>
                  </div>
                  <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <span class="carousel-control-custom-icon" aria-hidden="true">
                      <i class="fas fa-chevron-left"></i>
                    </span>
                    <span class="sr-only">Previous</span>
                  </a>
                  <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                    <span class="carousel-control-custom-icon" aria-hidden="true">
                      <i class="fas fa-chevron-right"></i>
                    </span>
                    <span class="sr-only">Next</span>
                  </a>
                </div>
        
           




              </div>
             
              <div class="card-footer clearfix">
                <a href="#" class="small-box-footer " style="float: right;">More info <i  class="fas fa-arrow-circle-right"></i></a>
              </div>

            </div> -->
          
          
            <div class="card card-danger card-outline">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="fas fa-bell mr-1"></i>
                Notifications
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content p-0">
                  
                  <div class="row">
                    <div class="col-12">
                     
                        <div class="post clearfix" *ngFor="let not of arrnotification">
                          <div class="user-block" style="margin-left:0px !important;margin-bottom:0px !important" >
                            
                            <span class="username" style="font-weight:bold;margin-left:0px !important">
                              <a style="color:red;">{{not.cron | date: 'dd MMMM, yyyy'}} {{not.cron | date: 'h:mm a'}} {{not.cron | date: 'EEEE'}}</a>
                            </span>
                            <!-- <span class="description" style="color:red;font-size:11px;margin-left:0px !important">{{not.cron | date: 'dd MMM, yyyy'}} {{not.cron | date: 'h:mm a'}} {{not.cron | date: 'EEEE'}}</span> -->
                          </div>
                          
                          <p style="font-size:16px;margin-bottom:0px !important">
                            {{not.nfcontent}}
                          </p>
    
                          <p>
                            <span *ngFor="let link of not.links">
                              <span class="spanlink"(click)="openlink(link.fpath)">{{link.fpath}}

                              </span>
                               &nbsp;</span>
                            <!-- <span *ngFor="let link of not.links">{{link.fpath}} &nbsp;</span> -->
                          </p>

                          <p>
                            <span *ngFor="let link of not.filelst;let i=index">
                              <span class="badge badge-success" title="View/Download" style="cursor: pointer" (click)="openfiles(link.fpath)"><i class="fa fa-paperclip"></i>
                                Attachment-{{i+1}}
                              </span>
                               &nbsp;</span>
                            <!-- <span *ngFor="let link of not.links">{{link.fpath}} &nbsp;</span> -->
                          </p>
                        </div>
    
                    
    
                       
                    </div>
                  </div>



                </div>
             
              </div>
              <div class="card-footer clearfix">
                <a routerLink="/app/notifications" class="small-box-footer " style="float: right;">More info <i  class="fas fa-arrow-circle-right"></i></a>
              </div>

            </div>
          
            <div class="card card-warning card-outline">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="ion ion-clipboard mr-1"></i>
                  To Do List
                </h3>

                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
               <div class="row">
                  <div class="col-12">
                   
                      <div class="post clearfix" *ngFor="let todo of arrassign">
                        <div class="user-block">
                        
                          <span class="username">
                            <!-- <a href="#">{{todo.for}}</a> -->
                            <span style="color: blue;font-weight:bold">{{todo.sunm}}</span>
                          </span>
                          <!-- <span></span> -->
                          <span class="description" style="color:green;font-size:12px;font-weight:bold;">{{todo.cntype}} Created On :{{todo.cndt}}</span>
                          
                        </div>
                        <!-- /.user-block -->
                        <p>
                         {{todo.cncontent}}
                        </p>
                        <p>
                          <span *ngFor="let link of todo.links">
                            <span class="spanlink"(click)="openlink(link.fpath)">{{link.fpath}}

                            </span>
                             &nbsp;</span>
                          <!-- <span *ngFor="let link of not.links">{{link.fpath}} &nbsp;</span> -->
                        </p>

                        <p>
                          <span *ngFor="let link of todo.filelst;let i=index">
                            <span class="badge badge-success" title="View/Download" style="cursor: pointer" (click)="openfiles(link.fpath)"><i class="fa fa-paperclip"></i>
                              Attachment-{{i+1}}
                            </span>
                             &nbsp;</span>
                          <!-- <span *ngFor="let link of not.links">{{link.fpath}} &nbsp;</span> -->
                        </p>
                        <p>
                          <span class="description " style="color: red;font-size:12px;" >Due On : {{todo.cnduedt}}</span>  
                        </p>
                      </div>
  
  
                     
                  </div>
                </div>
           
              </div>
              <!-- /.card-body -->
              <div class="card-footer clearfix">
                 <a routerLink="/app/dairy" class="small-box-footer " style="float: right;">More info <i  class="fas fa-arrow-circle-right"></i></a>
              </div>
            </div>
            <!-- /.card -->
          </section>
          <!-- /.Left col -->
          <!-- right col (We are only adding the ID to make the widgets sortable)-->
          <section class="col-lg-5 connectedSortable">

           <!-- TABLE: LATEST ORDERS -->



           <!-- <div class="card card-info card-outline ">
            <div class="card-header ">
            
              <h3 class="card-title"> 
                 <i class="fas fa-chart-pie mr-1"></i>
                 My Performance</h3>

                
                 
              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false">
                  <i class="fas fa-sync-alt"></i>
                </button>
              </div>
            </div>
          
           
            <div class="card-body">
              <div class=" card-widget widget-user">
               
                <div class="widget-user-header bg-info" style="margin: -20px; border-radius: 0px;margin-bottom: 37px;">
                  <h3 class="widget-user-username">Alexander Pierce</h3>
                  <h5 class="widget-user-desc">Founder &amp; CEO</h5>
                </div>
                <div class="widget-user-image">
                  <img class="img-circle elevation-2" src="assets/dist/img/no.jpg" alt="User Avatar">
                </div>
                <div class="row">
                  <div class="col-sm-4 border-right">
                    <div class="description-block">
                      <h5 class="description-header">3,200</h5>
                      <span class="description-text">SALES</span>
                    </div>
                    
                  </div>
                 
                  <div class="col-sm-4 border-right">
                    <div class="description-block">
                      <h5 class="description-header">13,000</h5>
                      <span class="description-text">FOLLOWERS</span>
                    </div>
                   
                  </div>
                 
                  <div class="col-sm-4">
                    <div class="description-block">
                      <h5 class="description-header">35</h5>
                      <span class="description-text">PRODUCTS</span>
                    </div>
                   
                  </div>
                
                </div>
              </div>


              <div class="table-responsive">
                <table class="table m-0">
                  <thead>
                  <tr>
                    <th>Assesment</th>
                    <th>Score</th>
                    <th>%</th>
                    <th>Rank</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td><a href="pages/examples/invoice.html">FA01</a></td>
                    <td>580/600</td>
                    <td><span class="badge badge-success">96.66%</span></td>
                    <td>
                      <div class="sparkbar" data-color="#00a65a" data-height="20">10<sup>th</sup> </div>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="pages/examples/invoice.html">FA02</a></td>
                    <td>580/600</td>
                    <td><span class="badge badge-warning">96.66%</span></td>
                    <td>
                      <div class="sparkbar" data-color="#f39c12" data-height="20">10<sup>th</sup> </div>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="pages/examples/invoice.html">SA01</a></td>
                    <td>580/600</td>
                    <td><span class="badge badge-danger">96.66%</span></td>
                    <td>
                      <div class="sparkbar" data-color="#f56954" data-height="20">10<sup>th</sup> </div>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="pages/examples/invoice.html">FA03</a></td>
                    <td>580/600</td>
                    <td><span class="badge badge-info">96.66%</span></td>
                    <td>
                      <div class="sparkbar" data-color="#00c0ef" data-height="20">10<sup>th</sup> </div>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="pages/examples/invoice.html">FA04</a></td>
                    <td>580/600</td>
                    <td><span class="badge badge-warning">96.66%</span></td>
                    <td>
                      <div class="sparkbar" data-color="#f39c12" data-height="20">10<sup>th</sup> </div>
                    </td>
                  </tr>
                  <tr>
                    <td><a href="pages/examples/invoice.html">SA02</a></td>
                    <td>580/600</td>
                    <td><span class="badge badge-danger">96.66%</span></td>
                    <td>
                      <div class="sparkbar" data-color="#f56954" data-height="20">10<sup>th</sup> </div>
                    </td>
                  </tr>
                 
                  </tbody>
                </table>

             
              </div>
            </div>
             
                <div class="card-footer clearfix">

                  
                  <a href="#" class="small-box-footer " style="float: right;">More info <i  class="fas fa-arrow-circle-right"></i></a>
  
                  </div>
            
         
             
        
           
          </div> -->
          <!-- /.card -->
        
            <!-- /.card -->

            <!-- Calendar -->

            <div  class="card card-success card-outline" *ngIf="enablejob=='YES'">
              <div class="card-header ">

                <h3 class="card-title">
                  <i class="far fa-calendar-alt"></i>
                 Job Postings
                </h3>
                <!-- tools card -->
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
                <!-- /. tools -->
              </div>

              <!-- /.card-header -->
              <div class="card-body ">
                <!--The calendar -->
                <div class="row">
                  <div class="col-12">
                   
                      <div class="post" *ngFor="let job of arrjobs">
                        <div class="user-block" style="margin-bottom: 0px;">
                        
                          <span >
                            <span style="color: #007bff;font-weight: bold;">{{job.jobtitle}} </span>&nbsp;&nbsp; <span style="color: green" *ngIf=" job.jstatus=='Active' && job.dstatus=='YES'"><i class="fa fa-check"></i> Applied</span> 
                            <span style="color: red" *ngIf=" job.jstatus=='Active' && job.dstatus=='NO'"><i class="fa fa-times"></i> Canceled</span>            
                          </span> 
                         <div class="row"><div class="col-md-8"><span class="description" style="margin-left:0px;width:60%">{{job.jpdt}}</span></div>
                         <div class="col-md-4">
                          <span class="badge badge-secondary" *ngIf="job.jstatus=='Expired'" style="float: right;" > Expired</span>
                          <span class="badge badge-success " *ngIf="job.jstatus=='Active'" style="float: right;">{{job.dleft}} days left</span></div></div>
                          <!-- <span style="width:100%">  <span class="description" style="margin-left:0px;width:60%">{{job.jpdt}}</span><span class="badge badge-success " style="float: right;width:40%">1 Day left</span> </span>  -->
                        </div>
                       
                       <div>
                          <span style="font-weight:bold ;">Company : </span><span>{{job.cpnm}}</span>
                        </div>

                        <div>
                          <span style="font-weight:bold ;">Package : </span><span>{{job.salpkg}}</span>
                        </div>

                        <div>
                          <span style="font-weight:bold ;">Job Description : </span><span>{{job.jobdis}}</span>
                        </div>
  
                        <div class="row"><div class="col-md-8"><span  style="margin-left:0px;width:60%;color: red;">Due Date : {{job.lastdt}}</span></div>
                         <div class="col-md-4"><span  class="badge badge-info spanbtn" *ngIf="job.jstatus=='Active' && (job.dstatus=='NA' || job.dstatus=='NO')" (click)="confirm_apply(job.jpid,job.jpdid)"> Apply</span> <span class="badge badge-danger spanbtn " *ngIf="job.jstatus=='Active' && job.dstatus=='YES'" (click)="confirm_cancel(job.jpdid)"> Cancel</span>
                           <i class="fas fa-link mr-1" style="float: right;"></i></div></div>
                      </div>  
  
                      <!-- <div class="post clearfix">
                        <div class="user-block">
                          <img class="img-circle img-bordered-sm" src="assets/dist/img/user7-128x128.jpg" alt="User Image">
                          <span class="username">
                            <a href="#">Annual Day</a> <span class="badge badge-success" style="float: right;">10 Day left</span>
                          </span>
                          <span class="description">Sent you a message - 3 days ago</span>
                        </div>
                      
                        <p>
                          Lorem ipsum represents a long-held tradition for designers,
                          typographers and the like. Some people hate it and argue for
                          its demise, but others ignore.
                        </p>
                        <p>
                         <a href="#" class="link-black text-sm " ><i class="fas fa-link mr-1"></i></a>
                        </p>
                      </div> -->
  
                    
                  </div>
                </div>

              


              </div>
              <!-- /.card-body -->
              <div class="card-footer clearfix">
                <a href="#" class="small-box-footer " style="float: right;">More info <i  class="fas fa-arrow-circle-right"></i></a>
              </div>

            </div>
            <div class="card card-success card-outline">
              <div class="card-header ">

                <h3 class="card-title">
                  <i class="far fa-calendar-alt"></i>
                 Upcoming Events
                </h3>
                <!-- tools card -->
                <!-- <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false">
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div> -->
            
              </div>

              <!-- /.card-header -->
              <div class="card-body ">
                <!--The calendar -->
                <div class="row">
                  <div class="col-12">
                   
                     
                    <div class="post clearfix" *ngFor="let todo of arrtodo">
                      <div class="user-block">
                      
                        <span class="username">
                          <!-- <a href="#">{{todo.for}}</a> -->
                          <span style="color: blue;font-weight:bold">{{todo.occname}}</span>
                        </span>
                        <!-- <span></span> -->
                        <span class="description" style="color:green;font-size:12px;font-weight:bold;"> Event Date :{{todo.holdt}}</span>
                        <span class="badge badge-success "  style="float: right;">{{todo.dleft}} days left</span>
                      </div>
                      <!-- /.user-block -->
                     
                    </div>
                    
                  </div>
                </div>

              


              </div>
              <!-- /.card-body -->
              <div class="card-footer clearfix">
                <a href="#" class="small-box-footer " style="float: right;">More info <i  class="fas fa-arrow-circle-right"></i></a>
              </div>

            </div>
           


            <!-- /.card -->
          </section>
          <!-- right col -->
        </div>
        <!-- /.row (main row) -->
      </div><!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
